module.exports = __webpack_public_path__ + "img/japan.e84e2073.png";